import {isJsonString} from "@js/globalFunctions/isJsonString";

export function determineOverrideParameters(){
	const overrideTriggers = ['between'];
	
	let parameters = {};
	let raw = false;
	
	if($('#pageContentSpecifik').length !== 0)
	{
		raw = $('#pageContentSpecifik').attr('data-overrideparameters');
	}
	else if($('#faneFeriehus').length !== 0)
	{
		raw = $('#faneFeriehus').attr('data-overrideparameters');
	}
	else if($('#bigMapFetcher').length !== 0)
	{
		raw = $('#bigMapFetcher').attr('data-overrideparameters');
	}
	
	if(raw !== false && isJsonString(raw))
	{
		const parsedParameters = JSON.parse(raw);
		const parsedKeys = Object.keys(parsedParameters);
		for(let i = 0; i < parsedKeys.length; i++)
		{
			if(typeof parsedParameters[parsedKeys[i]] === 'object' )
			{
				for(let x = 0; x < parsedParameters[parsedKeys[i]].length; x++)
				{
					if(overrideTriggers.indexOf(parsedParameters[parsedKeys[i]][x]) !== -1)
					{
						parameters[parsedKeys[i]] = parsedParameters[parsedKeys[i]];
						break;
					}
				}
			}
			else
			{
				if(overrideTriggers.indexOf(parsedParameters[parsedKeys[i]]) !== -1)
				{
					parameters[parsedKeys[i]] = parsedParameters[parsedKeys[i]];
					break;
				}
			}
		}
	}
	
	return parameters;
}
